import 'swiper/css';
import 'swiper/css/effect-fade';
import 'vanilla-calendar-pro/styles/layout.css';

import '../css/app.scss';

// UTILS
import DataLayer from '@utils/DataLayer';

import ButtonHover from '@utils/ButtonHover';
import CardVideo from '@utils/CardVideo';
import PrefersReducedMotion from '@utils/PrefersReducedMotion';
import ToggleVideo from '@utils/ToggleVideo';
import SetYoutubeVideoWithCookieOrNot from '@utils/SetYoutubeVideoWithCookieOrNot';
import PlayVideoInline from '@utils/PlayVideoInline';
import Animations from '@utils/Animations';
import DownloadFiles from '@utils/DownloadFiles';
import IntermediateCheckbox from '@utils/IntermediateCheckbox';
import I18n from '@utils/I18n';
import Socialize from '@utils/Socialize';
import FormsUtils from '@utils/FormsUtils';

// ELEMENTS
import Collapsable from '@elements/Collapsable/Collapsable';
import Dropdown from '@elements/Dropdown/Dropdown';
import Chip from '@elements/Chip/Chip';
import FloatInput from '@elements/Float_input/FloatInput';
import InputBase from '@elements/Forms/Input_base/InputBase';
import InputPhone from '@elements/Forms/Input_phone/InputPhone';
import Form from '@elements/Forms/Form/Form';
import FileUpload from '@elements/Forms/File_upload/FileUpload';
import Select from '@elements/Forms/Select/Select';
import Checkbox from '@elements/Forms/Checkbox/Checkbox/Checkbox';
import RadioButton from '@elements/Forms/Radio_button/Radio_button/RadioButton';
import Datepicker from '@elements/Forms/Datepicker/Datepicker';
import InputRange from '@elements/Forms/Input_range/InputRange';
import ScrollProgress from '@elements/Scroll_progress/ScrollProgress';

// BLOCKS
import Modal from '@blocks/modal/Modal';
import PECardSlider from '@blocks/cards/News_card/PE_card_slider/PECardSlider';
import ProductCard from '@blocks/cards/Product_card/ProductCard';
import TribuneCard from '@blocks/cards/Tribune_card/TribuneCard';
import OrganigramCard from '@blocks/cards/Organigram_card/OrganigramCard';
import Breadcrumbs from '@blocks/navigation/breadcrumbs/Breadcrumbs';
import Tabs from '@blocks/navigation/Tabs/Tabs';
import SearchBar from '@blocks/navigation/Search_bar/SearchBar';
import MultiSearchBar from '@blocks/navigation/Multi_search_bar/MultiSearchBar';
import Pagination from '@blocks/navigation/pagination/Pagination';
import SegmentedControl from '@blocks/navigation/Segmented_control/SegmentedControl';
import ArticleHeader from '@blocks/article/Article_header/ArticleHeader';
import ArticleActions from '@blocks/article/Article_actions/ArticleActions';
import ArticleFooter from '@blocks/article/Article_footer/ArticleFooter';

//MODULES
import CardSlider from '@modules/Distributor/CardSlider';
import NakedCardsSlider from '@modules/Distributor/Secondary_naked_cards/NakedCardsSlider';
import NakedNews from '@modules/Distributor/Naked_news/NakedNews';
import NewsCategories from '@modules/Distributor/News_categories/NewsCategories';
import Tribunes from '@modules/Distributor/Tribunes/Tribunes';
import PrimaryHeader from '@modules/Header/Primary_header/PrimaryHeader';
import ProductHeader from '@modules/Header/Product_header/ProductHeader';
import FormHeader from '@modules/Header/Form_header/FormHeader';
import NewsHeader from '@modules/Header/News_header/NewsHeader';
import FeaturedNews from '@modules/Content/Featured_news/FeaturedNews';
import ContentBlock from '@modules/Content/Content_block/ContentBlock';
import Accordion from '@modules/Content/Accordion/Accordion';
import Article from '@modules/Content/Article/Article';
import Logos from '@modules/Content/Logos/Logos';
import Testimonials from '@modules/Content/Testimonials/Testimonials';
import Downloads from '@modules/Content/Downloads/Downloads';
import ContentTable from '@modules/Content/Content_table/ContentTable';
import ContactInfo from '@modules/Content/Contact_info/ContactInfo';
import OrganigramBio from '@modules/Content/Organigram_Bio/OrganigramBio';
import Gallery from '@modules/Content/Gallery/Gallery';
import Organigram from '@modules/Content/Organigram/Organigram';
import Glossary from '@modules/Tools/Glossary/Glossary';
import Catalogue from '@modules/Tools/Catalogue/Catalogue';
import AutogasCalculator from '@modules/Tools/Calculators/Autogas_calculator/AutogasCalculator';
import News from '@modules/Tools/News/News';
import Sticky from '@modules/Tools/Sticky/Sticky';
import TableSearch from '@modules/Tools/Table_search/TableSearch';
import Co2Calculator from '@modules/Tools/Calculators/Co2_calculator/Co2Calculator';
import Forms from '@modules/Forms/Forms/Forms';
import NewsletterSubscription from '@modules/Forms/Newsletter_subscription/NewsletterSubscription';

//FOOTER
import MenuSlideDown from '@modules/Menu/Menu_slide_down/MenuSlideDown';

//FOOTER
import Footer from '@modules/Footer/Footer';

//PAGES
import BrandLanding from '@pages/Brand_landing/BrandLanding';

let domContentAlreadyLoaded = false;

document.addEventListener('DOMContentLoaded', (e) => {
  if (domContentAlreadyLoaded || !window.IS_STORYBOOK) {
    e.stopPropagation();

    DataLayer.init();

    ButtonHover.init();
    CardVideo.init();
    PrefersReducedMotion.init();
    ToggleVideo.init();
    SetYoutubeVideoWithCookieOrNot.init();
    PlayVideoInline.init();
    Animations.init();
    DownloadFiles.init();
    IntermediateCheckbox.init();
    I18n.init();
    Socialize.init();
    FormsUtils.init();

    Collapsable.init();
    Dropdown.init();
    Chip.init();
    FloatInput.init();
    InputBase.init();
    InputPhone.init();
    Form.init();
    FileUpload.init();
    Select.init();
    Checkbox.init();
    RadioButton.init();
    Datepicker.init();
    InputRange.init();
    ScrollProgress.init();

    Modal.init();
    PECardSlider.init();
    Breadcrumbs.init();
    ProductCard.init();
    TribuneCard.init();
    OrganigramCard.init();
    Tabs.init();
    SearchBar.init();
    MultiSearchBar.init();
    Pagination.init();
    SegmentedControl.init();
    ArticleHeader.init();
    ArticleActions.init();
    ArticleFooter.init();

    CardSlider.init();
    NakedCardsSlider.init();
    NakedNews.init();
    NewsCategories.init();
    Tribunes.init();
    PrimaryHeader.init();
    ProductHeader.init();
    FormHeader.init();
    NewsHeader.init();
    FeaturedNews.init();
    ContentBlock.init();
    Accordion.init();
    Article.init();
    Logos.init();
    Testimonials.init();
    Downloads.init();
    ContentTable.init();
    ContactInfo.init();
    OrganigramBio.init();
    Gallery.init();
    Organigram.init();
    Glossary.init();
    Catalogue.init();
    AutogasCalculator.init();
    News.init();
    Sticky.init();
    TableSearch.init();
    Co2Calculator.init();
    Forms.init();
    NewsletterSubscription.init();

    MenuSlideDown.init();

    Footer.init();

    BrandLanding.init();
  }

  domContentAlreadyLoaded = true;
});
